/**
 * Ícone de linha de cada tipo de ativo do cadastro — Nexora Grid (frontend, US-4603).
 *
 * Criado em: 02/11/2026 · Última modificação: 02/11/2026 · Versão: 1.0.0
 *
 * Traço na cor `--equipamento` (ISA-101: equipamento em cinza, cor só para condição anormal).
 */
const DESENHO: Record<string, string> = {
  poco_profundo: "M8 3h8M12 3v18M9 21h6M7 8h10v4H7z",
  bomba: "M4 13a5 5 0 1 0 10 0a5 5 0 1 0 -10 0M14 13h6M18 9v8M4 20h12",
  elevatoria: "M4 13a5 5 0 1 0 10 0a5 5 0 1 0 -10 0M14 13h6M18 9v8M3 4h18v3H3z",
  reservatorio: "M4 9c0-2 16-2 16 0v9c0 2-16 2-16 0zM4 13c4 1.5 12 1.5 16 0",
  macromedidor: "M3 12h4M17 12h4M7 8h10v8H7zM12 8V4h3",
  vrp: "M3 15h18M8 15V9h8v6M12 9V5M9 5h6",
  ponto_pressao: "M6 11a6 6 0 1 0 12 0a6 6 0 1 0 -12 0M12 11l3-3M12 17v4M9 21h6",
  registro: "M3 12h18M12 6v12M8 6h8",
  ventosa: "M3 16h18M12 16V8M8 8h8l-4-4z",
  hidrante: "M8 21V9a4 4 0 0 1 8 0v12M6 21h12M5 12h3M16 12h3",
};

export function IconeTipo({ tipo, grande }: { tipo: string; grande?: boolean }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" style={grande ? { width: 72, height: 72 } : undefined}>
      <path d={DESENHO[tipo] ?? "M4 4h16v16H4z"} />
    </svg>
  );
}
